import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Button, STYLE } from '@zocdoc-frontend-common/components-button';

/**
 * @param {string} className
 * @param {Image} icon
 * @param {string} message
 * @param {function(): void} onClick
 * @returns {JSX.Element}
 */
class BaseSocialLoginButtonTransparent extends PureComponent {
    render() {
        const { className, icon: Icon, message, onClick } = this.props;

        return (
            <StyledButton
                className={className}
                fluid
                onClick={onClick}
                variation={STYLE.TRANSPARENT}
                type="button"
            >
                <IconWrapper>
                    <Icon />
                </IconWrapper>
                <ButtonText>{message}</ButtonText>
            </StyledButton>
        );
    }
}

const IconWrapper = styled.span`
    align-items: center;
    bottom: 0;
    display: flex;
    left: 5px;
    position: absolute;
    top: 0;
`;

const ButtonText = styled.span`
    font-size: 15px;
`;

const StyledButton = styled(Button)`
    height: 40px;
    line-height: 1;
    outline: none;
    position: relative;
`;

export default BaseSocialLoginButtonTransparent;
